var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "p-3"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "kind-fleet"
    }
  }, [_vm._v("Fleet Category")]), _c('v-multiselect', {
    attrs: {
      "multiple": true,
      "track-by": "id",
      "placeholder": "Select multiple",
      "options": _vm.fleetTypeOpt,
      "label": "name",
      "value": "id",
      "id": "kind-fleet"
    },
    model: {
      value: _vm.form.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vehicle_type_ids", $$v);
      },
      expression: "form.vehicle_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])])], 1), _c('b-col', {
    staticClass: "d-flex flex-column mt-3",
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Date")]), _c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "type": "year"
    },
    model: {
      value: _vm.form.year,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "year", $$v);
      },
      expression: "form.year"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex flex-column my-3",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 bg-gray p-2 px-3 d-flex justify-content-between"
  }, [_c('h5', [_vm._v("Month")]), _c('h5', [_vm._v("Percentage")])])]), _c('b-col', {
    staticClass: "d-flex flex-column mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between px-3"
  }, [_c('label', [_vm._v("Set same value each month")]), _c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "size": "md"
    },
    model: {
      value: _vm.form.is_same_input,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_same_input", $$v);
      },
      expression: "form.is_same_input"
    }
  })], 1)]), _vm._l(_vm.form.target_per_months, function (item, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "12"
      }
    }, [_c('b-row', {
      staticClass: "mx-3 px-0 py-2 border-bottom"
    }, [_c('b-col', {
      attrs: {
        "lg": "3"
      }
    }, [_c('label', [_vm._v("Month " + _vm._s(item.month))])]), _c('b-col', {
      attrs: {
        "lg": "9"
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number"
      },
      on: {
        "input": _vm.handleChangeInput
      },
      model: {
        value: item.percentage_target,
        callback: function callback($$v) {
          _vm.$set(item, "percentage_target", $$v);
        },
        expression: "item.percentage_target"
      }
    })], 1)], 1)], 1)], 1);
  }), _c('b-col', {
    staticClass: "d-flex flex-column my-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-col', [_c('label', [_vm._v("Remarks")]), _c('b-form-textarea', {
    attrs: {
      "id": "textarea",
      "placeholder": "Enter something...",
      "rows": "3",
      "max-rows": "6"
    },
    model: {
      value: _vm.form.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex justify-content-end my-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary",
      "outline": ""
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(" Cancle and Close ")]), !_vm.loading ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "outline": ""
    },
    on: {
      "click": function click() {
        return _vm.handleSubmit();
      }
    }
  }, [_vm._v(" Submit ")]) : _c('b-button', {
    staticClass: "d-flex align-items-center px-3",
    attrs: {
      "variant": "primary",
      "outline": ""
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }